style= require('./dota-results.styl')
if match.season
  .wrapper.column
    .controls
      section
        if match.bout
          a(href="/matches/" + match._id + "/lineups")
            ft-button(warning) Match Setup
          each source in matchSources
            if canScrapeLineups(source)
              ft-button(warning, (click)=this.scrapeLineups(source))
                | Scrape #{source.source}
          sporty-match-times(match=match)
        else
          ft-button(warning, (click)=this.computeAggregate())
            | Compute aggregate stats
        sporty-feeds(match=match)
        ft-button(
          (click)= this.toggleAuto()
        )= `Auto-scraping ${match.stopFeeds ? 'disabled' : 'enabled'}`
        ft-button(success,
          (click)=this.sendFeeds(),
          disabled=match.$isSubmitting
        ) Send events
    .match
      sporty-status(match=match)
    if match.bout
      ft-button(success, (click)=this.editMode = !this.editMode)
        if(!this.editMode)
          | Edit stats
        else
          | Cancel
    .wrapper.column
      sporty-stats.block(
        match=match
        edit-mode=editMode
      )
    if this.editMode
      ft-button(success, (click)=this.saveStats())
        | Save
